export default "__VITE_ASSET__23e98c1a__"